import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import LeagueSeasonLeaderboardCreateEditForm from './Components/LeagueSeasonLeaderboardCreateEditForm';
import LeagueSeasonLeaderboardApi from './LeagueSeasonLeaderboardApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: LeagueSeasonLeaderboardCreateEditForm,
                getCreate: LeagueSeasonLeaderboardApi.create,
                getClone: LeagueSeasonLeaderboardApi.getOne,
                defaults: {},
                successMessage: "Leaderboard Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}